"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { ArrowRight, Play } from "lucide-react";
export function HeroSection() {
  return <section className="pt-32 pb-20 px-6" data-unique-id="ecafb008-34cb-437a-a50e-eaa9c68ee772" data-file-name="components/hero-section.tsx">
      <div className="max-w-7xl mx-auto" data-unique-id="5e4fd08b-cdad-4bc0-80fc-29922cb2bb68" data-file-name="components/hero-section.tsx">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-unique-id="49c6e0c7-baad-42eb-95d7-21eaa2264013" data-file-name="components/hero-section.tsx" data-dynamic-text="true">
          {/* Left Column - Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-8" data-unique-id="fc9891a6-89d7-4979-8288-fd3592f64dd0" data-file-name="components/hero-section.tsx">
            <div className="space-y-6" data-unique-id="4a1e44c4-0a07-4028-b7b1-59a37ef18032" data-file-name="components/hero-section.tsx">
              <motion.h1 initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.4
            }} className="text-5xl lg:text-6xl font-bold leading-tight" data-unique-id="dbd2a387-e9cb-4604-a900-aef49fca9633" data-file-name="components/hero-section.tsx"><span className="editable-text" data-unique-id="afe7048f-0b00-4543-a656-90cf77720a72" data-file-name="components/hero-section.tsx">
                Turn Complex Analysis into</span>{" "}
                <span className="gradient-text" data-unique-id="f2132bfd-f2f8-425b-941c-fb4e61c56047" data-file-name="components/hero-section.tsx"><span className="editable-text" data-unique-id="effc89b5-f33f-4ae6-a467-d356b5542135" data-file-name="components/hero-section.tsx">Winning Strategy</span></span>
              </motion.h1>
              
              <motion.p initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.6
            }} className="text-xl text-muted-foreground leading-relaxed max-w-lg" data-unique-id="4a7a0099-e985-41f6-88fb-56dadbff5823" data-file-name="components/hero-section.tsx"><span className="editable-text" data-unique-id="b3452596-19c2-423a-a067-d0f2754de4c1" data-file-name="components/hero-section.tsx">
                Acumena's AI-powered platform transforms complex business data into clear, actionable strategies. Make smarter decisions faster with guided workflows and instant visualizations.
              </span></motion.p>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.8
          }} className="flex flex-col sm:flex-row gap-4" data-unique-id="d3bb9580-6c88-4e59-98ae-7a790a33b172" data-file-name="components/hero-section.tsx">
              <Link href="https://system.acumena.my.id/?newAnalysis=true" className="gradient-button text-primary-foreground px-8 py-4 rounded-lg font-semibold text-lg inline-flex items-center justify-center gap-2 group" data-unique-id="362ab708-0aa9-4110-a289-a30fab2a9801" data-file-name="components/hero-section.tsx"><span className="editable-text" data-unique-id="2826998e-b876-4e72-8472-3d5a769de98c" data-file-name="components/hero-section.tsx">
                Start Your Free Analysis
                </span><ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              
              <button className="border-2 border-border text-foreground px-8 py-4 rounded-lg font-semibold text-lg inline-flex items-center justify-center gap-2 hover:bg-accent transition-colors" data-unique-id="541c399d-72f2-4da9-9387-af52f6d044d9" data-file-name="components/hero-section.tsx">
                <Play className="w-5 h-5" /><span className="editable-text" data-unique-id="d7a11c0d-76a7-4039-a609-c026b4d95f50" data-file-name="components/hero-section.tsx">
                Watch Demo
              </span></button>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 1.0
          }} className="flex items-center gap-6 text-sm text-muted-foreground" data-unique-id="afe4d864-fcf8-4e05-a45d-01a9539afb36" data-file-name="components/hero-section.tsx">
              <div className="flex items-center gap-2" data-unique-id="4eac4427-ea13-4127-b437-bba4e5dc5ded" data-file-name="components/hero-section.tsx">
                <div className="w-2 h-2 bg-accent-green rounded-full" data-unique-id="3d8dfd2b-1e71-4d6f-b56f-d47a83d97e19" data-file-name="components/hero-section.tsx"></div>
                <span data-unique-id="7340bcaa-9de5-4e6d-b97f-3e1c1f024ceb" data-file-name="components/hero-section.tsx"><span className="editable-text" data-unique-id="6423c037-a7e4-4aba-94f5-a246e9822d61" data-file-name="components/hero-section.tsx">No credit card required</span></span>
              </div>
              <div className="flex items-center gap-2" data-unique-id="b0d9c588-bbe8-4f16-8c09-7bcfaea84fd6" data-file-name="components/hero-section.tsx">
                <div className="w-2 h-2 bg-accent-amber rounded-full" data-unique-id="7aeff260-0dab-4f24-ba28-d8dd740911f8" data-file-name="components/hero-section.tsx"></div>
                <span data-unique-id="a91a33b1-dcef-4870-8e87-98ddd89e11df" data-file-name="components/hero-section.tsx"><span className="editable-text" data-unique-id="16fcc272-eb6b-4af6-ad13-205f230a8bca" data-file-name="components/hero-section.tsx">Free forever plan</span></span>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Column - Visual */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="relative" data-unique-id="a1820fdb-0a6f-43e0-9352-a9de7e1f52ad" data-file-name="components/hero-section.tsx" data-dynamic-text="true">
            <div className="relative bg-white rounded-2xl shadow-2xl border border-border overflow-hidden" data-unique-id="af616966-f7be-413b-b914-3af717af9135" data-file-name="components/hero-section.tsx">
              <img src="https://pre-built-images.s3.amazonaws.com/webapp-uploads/c71b0329a3dd9bde9e1dfd66cd2feee3.png" alt="Acumena IE Matrix Strategic Analysis Dashboard" className="w-full h-auto" data-unique-id="5e7ab26c-f4de-4ef8-bb1a-6b650fc78b14" data-file-name="components/hero-section.tsx" />
            </div>

            {/* Floating Elements */}
            <motion.div animate={{
            y: [-10, 10, -10]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }} className="absolute -top-4 -right-4 w-20 h-20 bg-gradient-to-br from-accent-green to-primary rounded-full opacity-20" data-unique-id="006ebd80-a577-49f9-8804-e3adc444085d" data-file-name="components/hero-section.tsx"></motion.div>
            <motion.div animate={{
            y: [10, -10, 10]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }} className="absolute -bottom-6 -left-6 w-16 h-16 bg-gradient-to-br from-accent-amber to-primary rounded-full opacity-20" data-unique-id="34bb3032-048c-4feb-ae79-611ed268f781" data-file-name="components/hero-section.tsx"></motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}